import React, { useState } from "react"

const CustomExpertGenerator = ({ onAddExpert, customExperts, onRemoveExpert, generateExpertUrl, fetchOptions }) => {
  const [isOpen, setIsOpen] = useState(true) // Open by default inside details
  const [expectation, setExpectation] = useState("")
  const [generating, setGenerating] = useState(false)
  const [error, setError] = useState(null)
  const [previewExpert, setPreviewExpert] = useState(null)
  const url = generateExpertUrl || "/dev/multi-expert-screening/generate-expert"
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(fetchOptions?.headers || {}) },
    ...fetchOptions,
  }
  if (options.headers) options.headers["Content-Type"] = "application/json"

  const handleGenerate = async () => {
    if (!expectation.trim()) return
    setGenerating(true)
    setError(null)
    try {
      const res = await fetch(url, {
        ...options,
        body: JSON.stringify({
           expectation,
           llm_config: { model: "gpt-4o", temperature: 0.7 }
        })
      })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const data = await res.json()
      setPreviewExpert(data.expert)
    } catch (e) {
      setError(e.message)
    } finally {
      setGenerating(false)
    }
  }

  const handleAdd = () => {
    if (previewExpert) {
      onAddExpert({
        ...previewExpert,
        expert_id: previewExpert.expert_id || `custom_${Date.now()}`
      })
      setPreviewExpert(null)
      setExpectation("")
      setIsOpen(false)
    }
  }

  return (
    <div className="text-sm">
      {/* 
      <button 
        className="font-semibold text-blue-800 flex items-center gap-1"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? "-" : "+"} Add Custom Expert (LLM-generated)
      </button>
      */}

      {isOpen && (
        <div className="space-y-2">
           <textarea 
             placeholder="What should this expert focus on?"
             className="w-full border rounded p-2"
             rows={2}
             value={expectation}
             onChange={e => setExpectation(e.target.value)}
           />
           <div className="flex items-center gap-2">
             <button 
               onClick={handleGenerate} 
               disabled={generating}
               className="bg-blue-600 text-white px-3 py-1 rounded disabled:bg-blue-300"
             >
               {generating ? "Generating..." : "Generate Expert"}
             </button>
             {error && <span className="text-red-600">{error}</span>}
           </div>

           {previewExpert && (
             <div className="bg-white dark:bg-gray-900 dark:bg-gray-900 p-3 border rounded mt-2">
               <h4 className="font-semibold mb-1">Preview: {previewExpert.name}</h4>
               <p className="text-gray-600 dark:text-gray-400 mb-2">{previewExpert.description}</p>
               <div className="flex gap-2">
                 <button onClick={handleAdd} className="bg-green-600 text-white px-3 py-1 rounded">Add Expert</button>
                 <button onClick={() => setPreviewExpert(null)} className="bg-gray-400 text-white px-3 py-1 rounded">Discard</button>
               </div>
             </div>
           )}
        </div>
      )}

      {/* List handled by parent */}
    </div>
  )
}

export default CustomExpertGenerator
